"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _uiTheme = require("@kyruus/ui-theme");
var _Phone = _interopRequireDefault(require("@kyruus/react-ikons/Phone"));
var _intl = require("@kyruus/intl");
var _messages = _interopRequireDefault(require("../../../lib/messages"));
var _Location = require("./Location.utils");
var _styles = require("./styles");
var _ProviderLocationsGmap = require("../ProviderLocations.gmap.utils");
var _PhoneNumberLink = _interopRequireDefault(require("../../PhoneNumberLink/PhoneNumberLink"));
const NonBookableLocation = (0, _uiTheme.withTheme)(_ref => {
  let {
    theme,
    name,
    phone,
    street1 = '',
    street2 = '',
    suite = '',
    city = '',
    state = '',
    zip = ''
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.NonBookableLocationContainer, {
    "data-testid": "ProviderLocations__Location"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Phone.default, {
    size: "18px",
    color: (0, _ProviderLocationsGmap.getNonBookableLocationColor)(theme)
  }), /*#__PURE__*/_react.default.createElement("div", {
    itemProp: "address",
    itemScope: true,
    itemType: "http://schema.org/PostalAddress"
  }, /*#__PURE__*/_react.default.createElement(_Location.Name, null, name), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_Location.Street, {
    street1: street1,
    street2: street2,
    suite: suite
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_Location.City, null, city, Boolean(state || zip) && ', '), /*#__PURE__*/_react.default.createElement(_Location.State, null, state, " "), /*#__PURE__*/_react.default.createElement(_Location.Zip, null, zip)))), /*#__PURE__*/_react.default.createElement(_styles.LocationMessage, {
    "data-testid": "LocationMessage"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.notBookableLocation), phone && /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_PhoneNumberLink.default, {
    phone: phone
  }))));
});
NonBookableLocation.propTypes = {
  name: _propTypes.string.isRequired,
  street1: _propTypes.string,
  street2: _propTypes.string,
  suite: _propTypes.string,
  city: _propTypes.string,
  state: _propTypes.string,
  zip: _propTypes.string,
  phone: _propTypes.string
};
var _default = exports.default = NonBookableLocation;